import {
  DataSource,
  ILoadable,
} from '../../Utils';
import {
  IComputationInput as IComputationInput_NonPartner,
} from './compute_NonPartner';
import compute_NonPartner from './compute_NonPartner';
import {
  IComputationInput as IComputationInput_Partner,
} from './compute_Partner';
import compute_Partner from './compute_Partner';
import {
  IInputFromURLRouting,
  IUIState,
} from './getReducer';
import {
  IHasNoError,
  ISuccessfulMergeAction,
} from './getReducer';
import {
  updateMergedData,
} from './reducer';
import {
  IComputationOutput,
} from './Utils';

export type IComputationInput = IComputationInput_Partner | IComputationInput_NonPartner;

interface IComputeInput {
  computationInput: IComputationInput;
  queueNumber: number;
  uiState: IUIState;
  inputFromURLRouting: IInputFromURLRouting;
}

const compute = (
    {computationInput, queueNumber, uiState, inputFromURLRouting}: IComputeInput,
  ): ISuccessfulMergeAction => {

  const {
    width, height,
  } = uiState;
  const  {
    productClass, country, queryLevel, product, tradeDirection, tradeFlow, year,
  } = inputFromURLRouting;



  let computedValue: ILoadable<IComputationOutput>;
  if (computationInput.source === DataSource.CPY) {
    computedValue = compute_NonPartner(computationInput);
  } else {
    computedValue = compute_Partner(computationInput);
  }

  const mergedData: IHasNoError = {
    hasError: false, value: computedValue,
  };

  const mergeResult = {
    mergedData, queueNumber,
    hashInput: {
      width, height,
      productClass, country, queryLevel, product, tradeDirection, tradeFlow, year,
    },
  };
  return updateMergedData(mergeResult);
};

export default compute;
